import EditQuote from './EditQuote';

export default EditQuote;
